export function PrincipalDashboardHeader() {
  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
        Principal Overview
      </h1>
      <p className="mt-1 text-sm text-slate-600">
        Operational snapshot for attendance, staff, and student performance.
      </p>
    </div>
  );
}
